import _ from "lodash";
import {PACKAGE_METADATA_TYPE_JSON} from "../../components/package-metadata-viewer";
import {REQUEST_SUCCESS} from "../request/requestActions";
import {PACKAGE_METADATA_FETCH} from "../../state/miscellaneous/miscellaneousActions";
import {CATALOG_RESOURCE_TYPE_METADATA_URL, getPackageExternalResources} from "../../utils/catalog";

const EXCLUDED_RESOURCE_TYPE = [CATALOG_RESOURCE_TYPE_METADATA_URL];

const miscellaneousMiddleware =
  ({getState}) =>
  next =>
  action => {
    switch (action.type) {
      case REQUEST_SUCCESS: {
        switch (action.payload.label) {
          case PACKAGE_METADATA_FETCH: {
            if (action.payload.extra.metadataType === PACKAGE_METADATA_TYPE_JSON) {
              // Dataportal
              if (action.payload.extra?.nodeType && !action.payload.response?.data) {
                action.payload.response = {
                  data: _.cloneDeep(action.payload.response),
                  type: action.payload.extra.nodeType
                };
              }

              if (action.payload.response.data) {
                const packageId = action.payload.extra.packageId;
                const packageMap = action.payload.extra.packageMap;

                const state = getState();
                const resourceMap = state.catalog.resourceMap;

                const selectedPackage = packageMap[packageId];

                if (selectedPackage?.license) {
                  action.payload.response.data.license = selectedPackage.license;
                }

                if ((selectedPackage?.resourceIdentifiers || []).length > 0) {
                  const downloadableResources = getPackageExternalResources(packageId, state.catalog).map(({id}) => id);
                  action.payload.response.data.resources = selectedPackage.resourceIdentifiers.reduce((acc, res) => {
                    const resource = {
                      id: res,
                      isDownloadable: downloadableResources.includes(res),
                      ...resourceMap[res]
                    };
                    delete resource.extensions;

                    if (!EXCLUDED_RESOURCE_TYPE.includes(resource.type)) {
                      acc.push(resource);
                    }

                    return acc;
                  }, []);
                }
              }
            }
            break;
          }

          default:
            break;
        }

        break;
      }

      default:
        break;
    }

    return next(action);
  };

export default miscellaneousMiddleware;
